module.exports = __webpack_public_path__ + "right.2vlE4wcW.svg";